<template>
  <!-- eslint-disable  -->
  <div>
    <div v-if="bundleWarning" class="bundle-policy-bound-alert p-3">
      <div class="row align-items-center justify-content-center no-gutters">
        <div class="col-7 col-max-width">
          <div role="alert" aria-atomic="true" class="p-0 rounded-0 text-left alert alert-warning">
            <p><strong>Policy Bound:</strong> {{ bindmsg }}</p>
          </div>
        </div>
        <div class="col-3 ml-3">
          <button type="submit" class="btn btn-primary btn" @click.prevent="navigateTo">{{ submitButtonLabel }}</button>
        </div>
      </div>
    </div>
    <div v-else-if="Array.isArray(formMessages)">
      <div
        v-for="(formMessage, i) in formMessages" :key="i"
        v-html="formMessage.message"
        :class="{'py-3 rounded-0' : isPolicyAlert, 'text-center' : isPolicyAlert, 'alert alert-warning': formMessage.type === 'warning', 'alert alert-danger': formMessage.type !== 'warning'}"
        role="alert"
        aria-atomic="true"
      >
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import common from '../../../services/common';
import fetchData from '../../../services/fetchData';
import { pageMixin } from '../../../mixins/pageMixin';
export default {
  props: ['pageData'],
  mixins: [pageMixin],
  data() {
    return {
      bindmsg: '',
    }
  },  
  created() {
  },
  methods: {
    async navigateTo() {      
      let HOQuoteId = sessionStorage.getItem('homeSessionData') ? JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId : '';
      let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;

      let newRoute = '';
      let currentNavLink;
      if (sessionStorage.getItem('currentNav') == 'homerc1' || sessionStorage.getItem('currentNav') == 'condorc1' || sessionStorage.getItem('currentNav') == 'rentersrc1') {
        newRoute = '/auto/name-insured';
        currentNavLink = `/pages/namedinsured/${AUQuoteId}`;
        sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
        this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
      } else if (sessionStorage.getItem('currentNav') == 'autorc1') {        
        newRoute = '/auto/carrier-matches';
        currentNavLink = `/pages/carriermatches/${AUQuoteId}`;
        // sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
        // this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
      } else if (sessionStorage.getItem('currentNav') == 'homerc2' || sessionStorage.getItem('currentNav') == 'condorc2' || sessionStorage.getItem('currentNav') == 'rentersrc2') {
        let autoCarrierType = sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
        if (autoCarrierType === '') {
            sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData')); 
          newRoute = '/auto/bundle/checkout';
        } else if (autoCarrierType === 'EZLYNXCARRIER') {
            sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
             this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId }); 
            newRoute = '/auto/non-end-to-end';
        } else {
          let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
          currentNavLink = JSON.parse(sessionStorage.getItem('autoRC1BindResponse')).Navigate;
          this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
          //change session data in storage
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData')); 
          newRoute = common.getRouteName(currentNavLink); 
        }
      } else if (sessionStorage.getItem('currentNav') == 'autorc2') {
        let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
        if (homeCarrierType === 'RATECARRIER' && sessionStorage.getItem('autobound') == 'true' && sessionStorage.getItem('homebound') != 'true') {
          let homeRC2Errors = JSON.parse(sessionStorage.getItem('homeRC2Errors'));
          let submitFrom = 'bundle';
          this.propertyBindsubmitted(homeRC2Errors, submitFrom, HOQuoteId);
        } else
          newRoute = '/auto/bundle/checkout';
        // currentNavLink = `/pages/carriermatches/${AUQuoteId}`;
      } else if (sessionStorage.getItem('currentNav') == 'listing') { 
        let autoCarrierType = sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
        let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
        if (autoCarrierType === 'EZLYNXCARRIER' && homeCarrierType === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData')); 
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId });
          newRoute = '/auto/non-end-to-end';
        } else if (homeCarrierType === 'EZLYNXCARRIER') {
          let homeSessionData;
          if (this.flowType === 'bundle') {
            homeSessionData = sessionStorage.getItem('homeSessionData');
            newRoute = '/home/non-end-to-end';
          } else if (this.flowType === 'cabundle') {
            newRoute = '/condo/non-end-to-end';
            homeSessionData = sessionStorage.getItem('condoSessionData');
          } else if (this.flowType === 'rabundle') {
            newRoute = '/renters/non-end-to-end';
            homeSessionData = sessionStorage.getItem('renterSessionData');
          }
          sessionStorage.setItem('sessionData', homeSessionData); 
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(homeSessionData).SessionId });
          // newRoute = '/home/non-end-to-end';
        } else {
        currentNavLink = `/pages/HORateCall2Details/${HOQuoteId}`;   //TODO:check carrierwise
        // if carrier is branch then we dont need to display dwelling tab. Display it for all other carriers
        if (this.$store.getters.getSelectedHomeCarrier.carrier_name.toLowerCase() !== 'branch') {
          this.$store.dispatch('sethomeRc2Nav', 'hodwelling', currentNavLink);
          sessionStorage.setItem('sethomeRc2Nav', 'hodwelling');
          sessionStorage.setItem('setRc2NavFlowAction', true);
          this.$store.dispatch('setRc2NavFlowAction', true);
          newRoute = '/home/dwelling';
        } else {
          const rateRequestParams = {
            url: `/pages/horatecall2details/${HOQuoteId}`,
          };
          await fetchData.getPageData(rateRequestParams).then((response) => {
            this.pageData = response.data;
            this.pageFieldsArray = this.pageData.fields;
            if (this.pageFieldsArray.some(field => field.section === 'Primary Mortgage' && field.visible)) {
              this.$store.dispatch('sethomeRc2Nav', 'homortgage');
              sessionStorage.setItem('sethomeRc2Nav', 'homortgage');
              sessionStorage.setItem('setRc2NavFlowAction', true);
              this.$store.dispatch('setRc2NavFlowAction', true);
              sessionStorage.setItem("mortgagehighlight", true);
              // this.$router.replace('/home/mortgage');
              newRoute = '/home/mortgage';
            } else {
              this.$store.dispatch('sethomeRc2Nav', 'hocoverage');
              sessionStorage.setItem('sethomeRc2Nav', 'hocoverage');
              sessionStorage.setItem('setRc2NavFlowAction', true);
              this.$store.dispatch('setRc2NavFlowAction', true);
              sessionStorage.setItem("mortgagehighlight", false);
              // this.$router.replace('/home/coverage');
              newRoute = '/home/coverage';
            }
          });
        }
        }
      } else if (sessionStorage.getItem('currentNav') == 'checkout') {        
        newRoute = '/auto/bundle/confirmation';
        currentNavLink = '';//`/pages/carriermatches/${AUQuoteId}`;
      }
      if (newRoute != '') {
        this.$store.dispatch('setCurrentNav', currentNavLink);
        this.$router.push(newRoute);
      }
    },
  },
  computed: {
    bundleWarning() {
      if (this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') {
      let currentNav = sessionStorage.getItem('currentNav');
        let autoCarrierType = sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
        let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : '';
        
        if (this.$router.currentRoute.path !== '/auto/carrier-matches' && autoCarrierType === 'EZLYNXCARRIER' && homeCarrierType === 'EZLYNXCARRIER' && sessionStorage.getItem('homebound') == 'true' && sessionStorage.getItem('autobound') == 'true') {
          return false;
        } else if (homeCarrierType == '' && autoCarrierType === 'EZLYNXCARRIER' && sessionStorage.getItem('autobound') == 'true') {
          return false;
        } else if (autoCarrierType == '' && homeCarrierType === 'EZLYNXCARRIER' && sessionStorage.getItem('homebound') == 'true') {
          return false;
        }

        return (((currentNav == 'homerc1' || currentNav == 'homerc2' || currentNav == 'condorc1' || currentNav == 'condorc2' || currentNav == 'rentersrc1' || currentNav == 'rentersrc2') && sessionStorage.getItem('homebound') == 'true') || ((currentNav == 'autorc1' || currentNav == 'autorc2') && sessionStorage.getItem('autobound') == 'true') || currentNav == 'listing' || currentNav == 'checkout');
      }
      return false; 
    },
    submitButtonLabel() {
      let flowname = this.flowType === 'bundle' ? 'home' : this.flowType === 'cabundle' ? 'condo' : 'renters';
      let currentNav = sessionStorage.getItem('currentNav');
      if (currentNav == 'homerc1' || currentNav == 'homerc2' || currentNav == 'condorc1' || currentNav == 'condorc2' || currentNav == 'rentersrc1' || currentNav == 'rentersrc2') {
        this.bindmsg = `This ${flowname} policy has been bound and changes cannot be made to this quote. Click the button to complete the auto policy.`;
        return 'Continue to Auto';
      } else if (currentNav == 'autorc1' || currentNav == 'autorc2') {
        this.bindmsg = `This auto policy has been bound and changes cannot be made to this quote. Click the button to complete the ${flowname} policy.`;
        return currentNav == 'autorc1' ? 'Continue to Carrier Matches' : 'Continue to Next Section';
      } else if (currentNav == 'listing') {
        this.bindmsg = 'This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.';
        return 'Continue to Next Section';
      } else if (currentNav == 'checkout') {
        this.bindmsg = 'This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.';
        return 'Continue to Next Section';
      }   
    },
    flowType() {
      return sessionStorage.getItem('flowType');
    },
    formMessages() {
      return (this.pageData ? this.pageData.Error : []);
    },
    isPolicyAlert() {
      if (this.formMessages && this.formMessages[0] && this.formMessages[0].message) {
        return this.formMessages[0].message.includes('Policy Bound');
      }
      return false;
    },
  },
  mounted() {
  },
};
</script>
<style scoped lang="scss">
  .form-messages {
    .bundle-policy-bound-alert {
      display: none;
    }
  }
  .bundle-policy-bound-alert {
    .col-max-width {
      max-width: 700px;
    }
    background-color: #FFEFC3 !important;
    border-color: #EAAA00 !important;
    .alert {
      border: none;
      color: #000;
      font-size: 14px;
      font-style: normal;
      p {
        margin: 0;
        float: left;
        width: 96%;
        padding-left: 10px;
      }
      &::before {
        float: left;
        margin-top: 10px;
      }
    }
    .btn {
      padding: 6px 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/presentational/alerts/FormAlerts.vue?839ebcac